export default {
	ponds: [],
	total: 0,
	limit: 10
};
